import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../../lib/utils';
const toneClasses = {
    danger: {
        solid: 'bg-danger text-white',
        soft: 'bg-danger-subtle text-danger-foreground',
    },
    info: {
        solid: 'bg-info text-white',
        soft: 'bg-info-subtle text-info-foreground',
    },
    neutral: {
        solid: 'bg-foreground text-background',
        soft: 'bg-muted text-muted-foreground',
    },
    success: {
        solid: 'bg-success text-white',
        soft: 'bg-success-subtle text-success-foreground',
    },
    warning: {
        solid: 'bg-warning text-white',
        soft: 'bg-warning-subtle text-warning-foreground',
    },
};
/**
 * Status pill bound to the semantic color tokens. Reach for this instead of
 * hand-rolling `bg-green-100 text-green-700` style chips across the app.
 */
function StatusBadge({ className, appearance = 'soft', children, dot = false, icon, tone, ...props }) {
    return (_jsxs("span", { className: cn('inline-flex items-center gap-1.5 whitespace-nowrap rounded-md px-2 py-0.5 text-xs font-medium [&_svg]:size-3.5 [&_svg]:shrink-0', toneClasses[tone][appearance], className), "data-slot": "status-badge", ...props, children: [dot && _jsx("span", { "aria-hidden": true, className: "size-1.5 rounded-full bg-current" }), icon, children] }));
}
export { StatusBadge };
